import {
    MainChipHeaderValues,
    SubChipHeaderValuesGraphColumn,
    SubChipHeaderValuesGraphLine,
    SubChipHeaderValuesModelNonTrend,
    SubChipHeaderValuesModelTrend,
} from '@pages-clean/admin/study/manage-panels/enums';
import { IMainChipData } from '@pages-clean/admin/study/manage-panels/interfaces';

export function getMainChipsMap(t: (key: string) => string): Record<MainChipHeaderValues, IMainChipData> {
    return {
        [MainChipHeaderValues.ModelNonTrend]: {
            value: MainChipHeaderValues.ModelNonTrend,
            text: t('chips.model.nonTrend.mainChipTitle'),
        },
        [MainChipHeaderValues.ModelTrend]: {
            value: MainChipHeaderValues.ModelTrend,
            text: t('chips.model.trend.mainChipTitle'),
        },
        [MainChipHeaderValues.GraphColumn]: {
            value: MainChipHeaderValues.GraphColumn,
            text: t('chips.graph.column.mainChipTitle'),
        },
        [MainChipHeaderValues.GraphDonut]: {
            value: MainChipHeaderValues.GraphDonut,
            text: t('chips.graph.donut.mainChipTitle'),
        },
        [MainChipHeaderValues.GraphHeatMap]: {
            value: MainChipHeaderValues.GraphHeatMap,
            text: t('chips.graph.heatmap.mainChipTitle'),
        },
        [MainChipHeaderValues.GraphLine]: {
            value: MainChipHeaderValues.GraphLine,
            text: t('chips.graph.line.mainChipTitle'),
        },
    };
}

export function getSubChipsListModelNonTrend(t: (key: string) => string) {
    return [
        {
            parentChipValue: MainChipHeaderValues.ModelNonTrend,
            value: SubChipHeaderValuesModelNonTrend.Funnel,
            text: t('chips.model.nonTrend.subChips.funnel'),
            selected: false,
        },
        {
            parentChipValue: MainChipHeaderValues.ModelNonTrend,
            value: SubChipHeaderValuesModelNonTrend.NegativeBinomial,
            text: t('chips.model.nonTrend.subChips.negativeBinomial'),
            selected: false,
        },
        {
            parentChipValue: MainChipHeaderValues.ModelNonTrend,
            value: SubChipHeaderValuesModelNonTrend.Poisson,
            text: t('chips.model.nonTrend.subChips.poisson'),
            selected: false,
        },
        {
            parentChipValue: MainChipHeaderValues.ModelNonTrend,
            value: SubChipHeaderValuesModelNonTrend.TRIOps,
            text: t('chips.model.nonTrend.subChips.triOps'),
            selected: false,
        },
        {
            parentChipValue: MainChipHeaderValues.ModelNonTrend,
            value: SubChipHeaderValuesModelNonTrend.TRIOpsDate,
            text: t('chips.model.nonTrend.subChips.triOpsDate'),
            selected: true,
        },
    ];
}

export function getSubChipsListModelTrend(t: (key: string) => string) {
    return [
        {
            parentChipValue: MainChipHeaderValues.ModelTrend,
            value: SubChipHeaderValuesModelTrend.FunnelTrend,
            text: t('chips.model.trend.subChips.funnelTrend'),
            selected: false,
        },
        {
            parentChipValue: MainChipHeaderValues.ModelTrend,
            value: SubChipHeaderValuesModelTrend.PoissonTrend,
            text: t('chips.model.trend.subChips.poissonTrend'),
            selected: false,
        },
        {
            parentChipValue: MainChipHeaderValues.ModelTrend,
            value: SubChipHeaderValuesModelTrend.TRIOpsTrend,
            text: t('chips.model.trend.subChips.triOpsTrend'),
            selected: false,
        },
        {
            parentChipValue: MainChipHeaderValues.ModelTrend,
            value: SubChipHeaderValuesModelTrend.ProportionsOT,
            text: t('chips.model.trend.subChips.proportionsOT'),
            selected: true,
        },
        {
            parentChipValue: MainChipHeaderValues.ModelTrend,
            value: SubChipHeaderValuesModelTrend.EventRatesOT,
            text: t('chips.model.trend.subChips.eventRatesOT'),
            selected: false,
        },
    ];
}

export function getSubChipsListGraphColumn(t: (key: string) => string) {
    return [
        {
            parentChipValue: MainChipHeaderValues.GraphColumn,
            value: SubChipHeaderValuesGraphColumn.Standard,
            text: t('chips.graph.column.subChips.siteStandard'),
            selected: true,
        },
        {
            parentChipValue: MainChipHeaderValues.GraphColumn,
            value: SubChipHeaderValuesGraphColumn.Range,
            text: t('chips.graph.column.subChips.range'),
            selected: false,
        },
        {
            parentChipValue: MainChipHeaderValues.GraphColumn,
            value: SubChipHeaderValuesGraphColumn.Stacked,
            text: t('chips.graph.column.subChips.stacked'),
            selected: false,
        },
    ];
}

export function getSubChipsListGraphLine(t: (key: string) => string) {
    return [
        {
            parentChipValue: MainChipHeaderValues.GraphLine,
            value: SubChipHeaderValuesGraphLine.SiteStandard,
            text: t('chips.graph.line.subChips.siteStandard'),
            selected: true,
        },
        {
            parentChipValue: MainChipHeaderValues.GraphLine,
            value: SubChipHeaderValuesGraphLine.SiteAverage,
            text: t('chips.graph.line.subChips.siteAverage'),
            selected: false,
        },
        {
            parentChipValue: MainChipHeaderValues.GraphLine,
            value: SubChipHeaderValuesGraphLine.SiteCumulative,
            text: t('chips.graph.line.subChips.siteCumulative'),
            selected: false,
        },
        {
            parentChipValue: MainChipHeaderValues.GraphLine,
            value: SubChipHeaderValuesGraphLine.Event,
            text: t('chips.graph.line.subChips.event'),
            selected: false,
        },
        {
            parentChipValue: MainChipHeaderValues.GraphLine,
            value: SubChipHeaderValuesGraphLine.SubjectStandard,
            text: t('chips.graph.line.subChips.subjectStandard'),
            selected: false,
        },
        {
            parentChipValue: MainChipHeaderValues.GraphLine,
            value: SubChipHeaderValuesGraphLine.SubjectVisit,
            text: t('chips.graph.line.subChips.subjectVisit'),
            selected: false,
        },
    ];
}
